import { useState, useEffect } from 'react';
import { Button, Checkbox } from '@material-tailwind/react';
import { Breadcrumbs } from 'components/breadcrumbs';
import useWindowWidth from 'utills/InitWidthDevice';
import { useParse, useTranslation } from '@refinedev/core';
import ApiService from 'utills/ApiService';
import { DEFAULT_PERMISSIONS } from 'utills/constants';
import { DocumentIcon, NewspaperIcon, PencilAltIcon, TableIcon, TagIcon } from '@heroicons/react/outline';
import { FullScreenLoading } from 'components/fullScreenLoading';
import toast from 'react-hot-toast';
import { isHaveActionPermission } from 'utills/helpers';

const RoleInformationDetail = (props: any) => {
  const { translate, isMobile, roleID, token } = props;
  const [roleInfo, setRoleInfo] = useState(null as any);
  const [loading, setLoading] = useState(false);

  const [permission, setPermission] = useState([] as any);

  const [fetchData, setFetchData] = useState(false);
  const [permissions, setPermissions] = useState(null as any);

  useEffect(() => {
    if (roleID && roleID !== '' && token && token !== '') {
      const intervalFetchData = setInterval(() => {
        setFetchData(true);
        clearInterval(intervalFetchData);
      }, 100);
    }
  }, [roleID, token]);

  useEffect(() => {
    if (fetchData) {
      fetchListPermission();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  const fetchListPermission = async () => {
    setLoading(true);
    try {
      const result = await ApiService.get(`role/organization/permissions`, token);

      if (result && result.length > 0) {
        const arr = [...DEFAULT_PERMISSIONS] as any;

        arr.forEach((item: any) => {
          for (let i = 0; i < result.length; i++) {
            const id = (result[i].resource === '') ? result[i].app : result[i].resource;
            const isPermissionMatched = result[i].resource === item.resource && result[i].app === item.app;

            if (isPermissionMatched) {
              if (result[i].action.length === 3) {
                item.disable = false;

                item.actions.forEach((action: any) => {
                  action.selected = false;
                  action.disable = false;
                })
              } else {
                if (result[i].action.length > 0) {
                  item.disable = false;

                  for (let j = 0; j < result[i].action.length; j++) {
                    item.actions.forEach((action: any, index: number) => {
                      if (index === 0) {
                        action.disable = false;
                      }

                      if (result[i].action[j] === action.id) {
                        action.selected = false;
                        action.disable = false;
                      }
                    })
                  }
                }
              }

            }

            if (result[i].app === item.id && !item.child) {
              item.disable = false;
            }
          }
        });

        fetchRoleInfo(arr);
      }
    } catch (error: any) {
      toast.error(error.message);
    }

    setLoading(false);
  }

  const fetchRoleInfo = async (pers: any) => {
    setLoading(true);
    try {
      const result = await ApiService.get(`role/${roleID}`, token);

      if (result) {
        setRoleInfo(result);
        const permission_temp = [...pers];

        if (result.permissions && result.permissions.length > 0) {
          result.permissions.forEach((item: any) => {
            for (let i = 0; i < permission_temp.length; i++) {
              if (item.resource === '') {
                const isPermissionMatched = permission_temp[i].app === item.app;
                if (isPermissionMatched && item.action && item.action.length > 0) {
                  for (let j = 0; j < permission_temp[i].actions.length; j++) {
                    if (item.action.includes(permission_temp[i].actions[j].id)) {
                      permission_temp[i].actions[j].selected = true;
                    }
                  }
                }
              } else {
                const isPermissionMatched = permission_temp[i].resource === item.resource && permission_temp[i].app === item.app;
                if (isPermissionMatched && item.action && item.action.length > 0) {
                  for (let j = 0; j < permission_temp[i].actions.length; j++) {
                    if (item.action.includes(permission_temp[i].actions[j].id)) {
                      permission_temp[i].actions[j].selected = true;
                    }
                  }
                }
              }
            }
          });
        };

        permission_temp.forEach((item: any) => {
          if (item.actions.length > 0) {
            let action_count = 0;
            let all = 0;

            item.actions.forEach((action: any) => {
              if (!action.disable) {
                action_count = action_count + 1;
              }

              if (action.selected) {
                all = all + 1;
              };
            });

            if (all === action_count - 1) {
              item.actions[0].selected = true;
            }
            
          }
        });

        setPermission([...permission_temp]);
      }
    } catch (error: any) {
      toast.error(error.message);
    }

    setFetchData(false);
    setLoading(false);
  }

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);

      if (userData?.type === 'wps') {
        const roles = [] as any;

        userData.permissions.forEach((item: any) => {
          const obj = {
            id: (item.resource !== "") ? item.resource : item.app,
            permissions: item.action,
            parrent: item.app
          };

          roles.push(obj);

          setPermissions(roles);

        });
      }
    }
  }, []);

  return (
    <div className="w-full bg-white">
      <div className="w-full p-[16px] bg-white rounded-[8px] border-b border-[#c5ccd2] flex items-center justify-between">
        <div className={`${isMobile ? 'text-16' : 'text-20'} font-700`}>{translate('role-information')}</div>

        {
          (roleInfo && roleInfo.name && roleInfo.name.toLowerCase() !== 'owner') &&
          <>
            {isHaveActionPermission(
              "role",
              "organization",
              "edit",
              permissions
            ) && (
              <a href={`/organization/role/${roleID}/edit`}>
                <Button
                  {...({} as any)}
                  className="h-[42px] px-[16px] flex items-center justify-center text-14 text-brand-500 border border-brand-500 rounded-[4px] bg-white gap-[8px]"
                >
                  <PencilAltIcon className="w-4 h-4 icon-edit" />
                  {!isMobile && <span>{translate("btn-edit")}</span>}
                </Button>
              </a>
            )}
          </>
        }

      </div>
      {
        roleInfo &&
        <div className="w-full p-[16px]">
          <div className={`${isMobile ? 'flex-col py-[8px]' : 'items-center gap-[40px] h-[72px]'} w-full flex border-b border-[#c5ccd2]`}>
            <div className="w-[220px] flex items-center gap-x-[16px]">
              <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                <TagIcon className="size-[16px] text-[#f1600d]" />
              </div>

              <span className='text-14 font-500'>{translate('status')}</span>
            </div>

            <div className={`${isMobile && 'pl-[56px]'} text-14 text-[#262626]`}>{(roleInfo.is_active) ? translate('active') : translate('in-active')}</div>
          </div>

          <div className={`${isMobile ? 'flex-col py-[8px]' : 'items-center gap-[40px] h-[72px]'} w-full flex border-b border-[#c5ccd2]`}>
            <div className="w-[220px] flex items-center gap-x-[16px]">
              <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                <DocumentIcon className="size-[16px] text-[#f1600d]" />
              </div>

              <span className='text-14 font-500'>{translate('role-name')}</span>
            </div>

            <div className={`${isMobile && 'pl-[56px]'} text-14 text-[#262626]`}>{roleInfo.name}</div>
          </div>

          <div className={`${isMobile ? 'flex-col py-[8px]' : 'items-center gap-[40px] h-[72px]'} w-full flex border-b border-[#c5ccd2]`}>
            <div className="w-[220px] flex items-center gap-x-[16px]">
              <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                <NewspaperIcon className="size-[16px] text-[#f1600d]" />
              </div>

              <span className='text-14 font-500'>{translate('role-description')}</span>
            </div>

            <div className={`${isMobile && 'pl-[56px]'} text-14 text-[#262626]`}>{roleInfo.description}</div>
          </div>

          <div className="w-full h-[72px] flex items-center gap-[40px]">
            <div className="w-[220px] flex items-center gap-x-[16px]">
              <div className="size-[40px] rounded-full flex items-center justify-center bg-[#feefe7]">
                <TableIcon className="size-[16px] text-[#f1600d]" />
              </div>

              <span className='text-14 font-500'>{translate('access-permissions')}</span>
            </div>

            <div className={`${isMobile && 'pl-[56px]'} text-14 text-[#262626]`}></div>
          </div>

          <div className={`${isMobile ? 'mt-[8px]' : 'mt-[32px] gap-[8px]'} w-full grid grid-cols-1`}>
            {
              permission.map((item: any, index: number) => {
                return (
                  <div className={`w-full bg-[#f6f5fe80] ${isMobile ? `p-[16px] flex flex-col rounded-[8px] ${!item.child && 'mt-[8px]'}` : 'h-[40px] flex items-center justify-between p-[24px]'} ${item.child && 'border-t border-[#c5ccd2]'}`} key={`${item.id}_${index}`} style={{ display: item.disable && 'none' }}>
                    <div className={`${isMobile ? 'w-full' : 'w-[30%]'} flex items-center gap-[8px]`}>
                      {
                        item.icon !== '' &&
                        <img src={item.icon} alt="icon-permission" className="size-[24px]" />
                      }

                      {translate(item.name)}
                    </div>

                    <div className={`${isMobile ? 'w-full grid grid-cols-2 gap-[8px]' : 'flex-1 flex items-center justify-between'}`}>
                      {
                        item.actions.map((checkboxItem: any, i: number) => {
                          return (
                            <div className="flex items-center gap-[8px]" key={checkboxItem.label} style={{ visibility: (checkboxItem.disable) && 'hidden'}}>
                              <Checkbox
                                checked={checkboxItem.disable ? false : checkboxItem.selected}
                                className="checkbox"
                                disabled={true}
                                {...{} as any}
                              />

                              <div className="checkbox-label">{translate(checkboxItem.label)}</div>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      }

      {
        loading &&
        <FullScreenLoading />
      }
    </div>
  )
}

const WPSRolesDetail = () => {
  const windowWidth = useWindowWidth();
  const [isMobile, setIsMobile] = useState(false);
  const { translate } = useTranslation();
  const parse = useParse();
  const { params } = parse();
  const [roleID, setRoleID] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  useEffect(() => {
    if (params && params?.id && params?.id !== '') {
      setRoleID(params?.id);
    }
  }, [params]);

  const breadcrumbItems = [
    {
      label: translate('organization'),
      href: ''
    },
    {
      label: translate('role-management'),
      href: '/organization/role'
    },
    {
      label: translate('role-information'),
      href: ''
    },
  ];

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  return (
    <div className="w-full">
      <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />

      {
        (roleID !== '' && token !== '') &&
        <div className='w-full p-[16px]'>
          <RoleInformationDetail
            isMobile={isMobile}
            translate={translate}
            roleID={roleID}
            token={token} />
        </div>
      }

    </div>
  )
};

export default WPSRolesDetail;